import * as React from 'react'

import Button from '@doordash/component-button'

import t from './strings'
import routes from '../../../../routes'
import { UndecoratedLink } from './styles'

const LearnMore = () => (
  <UndecoratedLink to={routes.deliveryIssuesExplanation.path}>
    <Button
      isInline
      type={Button.Types.FlatPrimary}
      padding={Button.Padding.None}
    >
      {t.learnMore()}
    </Button>
  </UndecoratedLink>
)

export default LearnMore
